<i18n>
{
  "en": {
    "site_guide": "Site Guide",
    "home": "Home",
    "popular_movie_ranking": "Rankings",
    "sign_up": "Sign Up",
    "actresses": "Girls",
    "upgrade": "Upgrade",
    "highspeed_plans": "Highspeed Plan",
    "movies": "Movies",
    "all_movies_list": "All Movies",
    "categories": "Categories",
    "series": "Series",
    "vip_movies": "VIP Movies",
    "svip_movies": "SVIP Movies",
    "annual_movies": "Annual Movies",
    "help": "Help",
    "member_services": "Member Services",
    "contact": "Contact",
    "site_map": "Sitemap",
    "agreement": "Agreement",
    "privacy": "Privacy",
    "recommended_sites": "Recommended Sites",
    "site_carib": "Caribbeancom",
    "site_caribpr": "Caribbeancom Premium",
    "site_dxlive": "DX LIVE",
    "site_1pondo": "1pondo",
    "site_10musume": "10musume",
    "site_heyzo": "HEYZO",
    "site_paco": "Pacopacomama"
  },
  "ja": {
    "site_guide": "サイトガイド",
    "home": "ホーム",
    "popular_movie_ranking": "人気ランキング",
    "sign_up": "入会案内",
    "actresses": "女のコ",
    "upgrade": "アップグレード案内",
    "highspeed_plans": "ハイスピードプラン",
    "movies": "動画",
    "all_movies_list": "全動画リスト",
    "categories": "カテゴリー",
    "series": "シリーズ",
    "vip_movies": "VIP動画",
    "svip_movies": "超VIP動画",
    "annual_movies": "年間動画",
    "help": "ヘルプ",
    "member_services": "会員サービス",
    "contact": "お問い合わせ",
    "site_map": "サイトマップ",
    "agreement": "利用規約",
    "privacy": "プライバシー",
    "recommended_sites": "おすすめサイト",
    "site_carib": "カリビアンコム",
    "site_caribpr": "カリビアンコムプレミアム",
    "site_dxlive": "ライブチャット DXLIVE",
    "site_1pondo": "一本道",
    "site_10musume": "天然むすめ",
    "site_heyzo": "HEYZO",
    "site_paco": "パコパコママ"
  }
}
</i18n>

<template>
  <footer>
    <div class="container">
      <div class="footer-main">
        <div class="footer-menu">
          <div class="menu-label" @click="toggleMenu('movies')" :class="{ 'is-open' : menuSelected['movies'] }">{{ $t('movies') }}<i class="iconf-add footer-menu-icon"></i></div>
          <div class="footer-menu-contents">
            <ul>
              <li @click="clickTrack('Footer','All List');"><router-link to="/list/?page=1&o=newest">{{ $t('all_movies_list') }}</router-link></li>
              <li v-if="!newXPEligible" @click="clickTrack('Footer','VIP Movies');"><router-link to="/search/?c=50000">{{ $t('vip_movies') }}</router-link></li>
              <li v-if="!newXPEligible" @click="clickTrack('Footer','SVIP Movies');"><router-link to="/search/?c=50001">{{ $t('svip_movies') }}</router-link></li>
              <li @click="clickTrack('Footer','Category');"><router-link to="/category/">{{ $t('categories') }}</router-link></li>
            </ul>
          </div>
        </div>
        <div class="footer-menu" v-if="!newXPEligible">
          <div class="menu-label" @click="toggleMenu('member')" :class="{ 'is-open' : menuSelected['member'] }">{{ $t('member_services') }}<i class="iconf-add footer-menu-icon"></i></div>
          <div class="footer-menu-contents">
            <ul>
              <li @click="clickTrack('Footer','Guide Upgrade');"><router-link to="/upgrade/">{{ $t('upgrade') }}</router-link></li>
            </ul>
          </div>
        </div>
        <div class="footer-menu">
          <div class="menu-label" @click="toggleMenu('guide')" :class="{ 'is-open' : menuSelected['guide'] }">{{ $t('site_guide') }}<i class="iconf-add footer-menu-icon"></i></div>
          <div class="footer-menu-contents">
            <ul>
              <li @click="clickTrack('Footer','Help');"><router-link to="/faq/">{{ $t('help') }}</router-link></li>
              <li @click="clickTrack('Footer','Contact');"><router-link to="/contact/">{{ $t('contact') }}</router-link></li>
              <li @click="clickTrack('Footer','Sitemap');"><router-link to="/sitemap/">{{ $t('site_map') }}</router-link></li>
              <li @click="clickTrack('Footer','Agreement');"><router-link to="/agreement/">{{ $t('agreement') }}</router-link></li>
              <li @click="clickTrack('Footer','Privacy');"><router-link to="/privacy/">{{ $t('privacy') }}</router-link></li>
              <li @click="clickTrack('Footer','Notice at Collection');" class="sub-item"><a :href="`/static/files/${locale}/notice_at_collection.pdf`" target="_blank" rel="noopener">Notice at Collection </a></li>
              <li @click="clickTrack('Footer','Content Removal');"><a href="https://service.allbrightinformation.com/content-removal/inquiry/" target="_blank" rel="noopener">Content Removal </a></li>
            </ul>
          </div>
        </div>
        <div class="footer-menu">
          <div class="menu-label" @click="toggleMenu('sites')" :class="{ 'is-open' : menuSelected['sites'] }">{{ $t('recommended_sites') }}<i class="iconf-add footer-menu-icon"></i></div>
          <div class="footer-menu-contents">
            <ul v-if="isSiteMember">
              <li @click="clickTrack('Footer','Caribbeancom');"><a href="https://www.caribbeancom.com/index2.htm" target="_blank" rel="noopener">{{ $t('site_carib') }}</a></li>
              <li @click="clickTrack('Footer','Caribbeancompr');"><a href="https://www.caribbeancompr.com/index2.html" target="_blank" rel="noopener">{{ $t('site_caribpr') }}</a></li>
              <li @click="clickTrack('Footer','1pondo');"><a href="https://www.1pondo.tv/?agecheck=no" target="_blank" rel="noopener">{{ $t('site_1pondo') }}</a></li>
              <li @click="clickTrack('Footer','10musume');"><a href="https://www.10musume.com/?agecheck=no" target="_blank" rel="noopener">{{ $t('site_10musume') }}</a></li>
              <li @click="clickTrack('Footer','Pacopacomama');"><a href="https://www.pacopacomama.com/?agecheck=no" target="_blank" rel="noopener">{{ $t('site_paco') }}</a></li>
              <li @click="clickTrack('Footer','DXLive');"><a href="https://www.dxlive.com/member?NetiFL=1" target="_blank" rel="noopener">{{ $t('site_dxlive') }}</a></li>
            </ul>
            <ul v-if="!isSiteMember">
              <li @click="clickTrack('Footer','Caribbeancom');"><a href="https://clear-tv.com/redir.fcgi?click=1400&site=6&b=1400&lang=tokyo" target="_blank" rel="noopener">{{ $t('site_carib') }}</a></li>
              <li @click="clickTrack('Footer','Caribbeancompr');"><a href="https://clear-tv.com/redir.fcgi?click=1400&site=290&b=1400&lang=tokyo" target="_blank" rel="noopener">{{ $t('site_caribpr') }}</a></li>
              <li @click="clickTrack('Footer','1pondo');"><a href="https://clear-tv.com/redir.fcgi?click=1400&site=18&b=1400&lang=tokyo" target="_blank" rel="noopener">{{ $t('site_1pondo') }}</a></li>
              <li @click="clickTrack('Footer','10musume');"><a href="https://clear-tv.com/redir.fcgi?click=1400&site=292&b=1400&lang=tokyo" target="_blank" rel="noopener">{{ $t('site_10musume') }}</a></li>
              <li @click="clickTrack('Footer','Pacopacomama');"><a href="https://clear-tv.com/redir.fcgi?click=1400&site=320&b=1400&lang=tokyo" target="_blank" rel="noopener">{{ $t('site_paco') }}</a></li>
              <li @click="clickTrack('Footer','DXLive');"><a href="https://clear-tv.com/redir.fcgi?click=1400&site=103&b=1400&lang=tokyo" target="_blank" rel="noopener">{{ $t('site_dxlive') }}</a></li>
            </ul>
          </div>
        </div>
        <div class="footer-menu is-pr" v-if="locale === 'ja'">
          <div class="menu-label">PR</div>
          <div class="footer-menu-contents">
            <ul>
              <li><a href="https://www.adultmango.com/cgi-bin/ranklink.cgi?id=paco2" target="_blank" rel="noopener">アクセスランキング</a></li>
              <li><a href="https://www.affiliate-dti.com/" target="_blank" rel="noopener">アダルトアフィリエイト</a></li>
              <li><a href="https://clear-tv.com/redir.fcgi?click=1400&site=100&b=1400&lang=tokyo" target="_blank" rel="noopener">チャットレディのお仕事</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer-sub">
        <div class="footer-sub--brand">
          <router-link to="/"><img :src="`/img/common/${locale === 'ja' ? 'mura-logo' : 'mura-logo-en'}.svg`" class="footer-logo" alt=""></router-link>
        </div>
        <div class="footer-sub--copyright">
          <div>&copy; {{ currentYear }} muramura.tv</div>
          <div>v{{ appVersion }}</div>
        </div>
        <div class="footer-sub--language">
          <div class="lang-switcher">
            <select v-once @change="localeChange($event)" class="form-control">
              <option v-for="(item, index) in localeOptions" :value="item.value" :selected="locale === item.value" :key="index">{{ item.label }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-extra">
      <div class="container">
        <router-link to="/2257/">18 USC &#167; 2257 Record-Keeping Requirements</router-link>
        <router-link to="/human-rights-policies/">Human Rights Policies</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
/* eslint max-len: 0 */
import APP_CONFIG from '@/appConfig';

export default {
  data() {
    return {
      menuSelected: {
        movies: false,
        member: false,
        guide: false,
        sites: false,
      },
    };
  },
  created() {
    // non-reactive consts
    this.currentYear = (new Date()).getFullYear();
    this.appVersion = APP_CONFIG.app.version;
    this.localeOptions = [
      { value: 'en', label: 'English', url: 'https://en.muramura.tv/' },
      { value: 'ja', label: '日本語', url: 'https://www.muramura.tv/' },
    ];
  },
  methods: {
    toggleMenu(name) {
      this.menuSelected[name] = !this.menuSelected[name];
    },
    clickTrack(category, action, label = null, value = null) {
      this.$analytics.trackEvent(category, action, label, value);
    },
    localeChange(e) {
      const selectedIdx = e.target.options.selectedIndex;
      window.location = this.localeOptions[selectedIdx].url;
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    newXPEligible() {
      return this.$store.getters['user/isNewXPEligible'];
    },
    isSiteMember() {
      return this.$store.getters['user/isSiteMember'];
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
